const SECTION_NAMES: Record<string, string> = {
  sales: 'Планирование продаж',
  purchase: 'Планирование закупок',
  references: 'Справочники',
  admin: 'Администрирование',
  notifications: 'Уведомления',
  settings: 'Настройки',
};

const ADMIN_PAGE_NAMES: Record<string, string> = {
  monitoring: 'Мониторинг',
  users: 'Пользователи',
  roles: 'Роли',
  sync: 'Синхронизация Entra',
  audit: 'Журнал аудита',
  'feature-flags': 'Feature Flags',
};

function formatStageId(stageId: string): string {
  const match = stageId.match(/^stage-(\d+)$/);
  if (match) return `Этап ${match[1]}`;
  return stageId;
}

/**
 * Определяет человекочитаемое название текущей страницы из URL.
 *
 * @param tableTitle — если передано, добавляется через тире
 * @returns  например "Планирование продаж / Этап 4 — Распределение МП"
 */
export function getPageLocation(tableTitle?: string): string {
  const pathname = window.location.pathname;
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return tableTitle ? `Главная — ${tableTitle}` : 'Главная';

  const section = segments[0];
  const sectionName = SECTION_NAMES[section] ?? section;

  let location = sectionName;

  if (section === 'admin' && segments[1]) {
    const adminPage = ADMIN_PAGE_NAMES[segments[1]] ?? segments[1];
    location = `${sectionName} / ${adminPage}`;
  } else if ((section === 'sales' || section === 'purchase') && segments[1]) {
    location = `${sectionName} / ${formatStageId(segments[1])}`;
  } else if (section === 'references' && segments[1]) {
    location = `${sectionName} / ${segments[1]}`;
  }

  if (tableTitle) {
    location = `${location} — ${tableTitle}`;
  }

  return location;
}
